import React, { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Stack,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  IconButton,
  Typography,
  Alert,
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { Icon } from '@iconify/react/dist/iconify.js';
import Addskill from './AddSkill';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { deleteKra, getAllKras } from '../../../../redux/features/appraisalSlice';
import ImportData from '../ImportData';
import ExportData from '../ExportData';
import Loader3D from '../../../../components/Loader/Loader3D';
import GlobalTableNoPagination from '../../../../components/CustomTableWithPagination/GlobalTableNoPagination';

const Skilllibrary = () => {
  const [rows, setRows] = useState([]);
  const [externalOpen, setExternalOpen] = useState(false);
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
    checkedRowIds: [],
  });

  const [modalState, setModalState] = useState({
    actionKey: '',
    row: null,
  });

  const handleButtonActionClick = useCallback((actionKey, row, actionType) => {
    if (!actionKey || !row) return;

    setModalState({
      actionKey,
      row,
    });

    if (actionKey === 'DELETE') {
      handleDelete(row.appraisal_library_id);
    }
    if (actionKey == 'EDIT') {
      setExternalOpen(true);
    }
  }, []);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { loading, kralibraries } = useSelector((state) => state.appraisal);

  const handleDeleteSelected = async () => {
    const selectedIds = tableState.checkedRowIds;

    if (selectedIds.length === 0) return;

    try {
      await dispatch(deleteKra(selectedIds)).unwrap();
      enqueueSnackbar(`${selectedIds.length} Skill's deleted`, {
        variant: 'success',
      });
       dispatch(getAllKras(data));
    } catch (error) {
      enqueueSnackbar('Failed to delete selected Skill', { variant: 'error' });
    }
  };

  const handleDelete = async (id) => {
    try {
      await dispatch(deleteKra([id])).unwrap();
      enqueueSnackbar('Skill deleted', { variant: 'success' });
       dispatch(getAllKras(data));
    } catch (error) {
      enqueueSnackbar('Failed to delete Skill', { variant: 'error' });
    }
  };

  const data = {
    search: '',
    type: 'skills',
  };

  useEffect(() => {
    dispatch(getAllKras(data));
  }, []);

  return (
    <Box>
      <Box>
        <Box
          mb={2}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: 1,
          }}
        >
          <Button
            variant="contained"
            color="error"
            size="small"
            startIcon={<Delete />}
            disabled={tableState.checkedRowIds.length === 0}
            onClick={handleDeleteSelected}
          >
            Delete
          </Button>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
            <Addskill dispatchData={data} />
            <ImportData dispatchData={data} library={'kra'} />
          </Stack>
        </Box>
      </Box>
      <GlobalTableNoPagination
        headers={[
          {
            field: 'appraisal_library_id',
            headerName: 'ID',
            width: 100,
          },
          {
            field: 'appraisal_library_name',
            headerName: 'KRA',
            width: 350,
          },
          {
            field: 'appraisal_library_description',
            headerName: 'Description',
            width: 400,
          },
          {
            field: 'delete',
            headerName: 'Delete',
            type: 'action',
            actionType: 'delete',
            actionKey: 'DELETE',
            buttonName: 'Delete',
            width: 100,
          },
          {
            field: 'edit',
            headerName: 'Edit',
            type: 'action',
            actionType: 'edit',
            actionKey: 'EDIT',
            hover: 'Edit',
            width: 100,
          },
        ]}
        tableState={tableState}
        setTableState={setTableState}
        loading={loading}
        rows={kralibraries || []}
        rowUniqueId="appraisal_library_id"
        checkboxNeeded={true}
        onButtonActionClick={handleButtonActionClick}
      />

      {externalOpen && (
        <Addskill
          edit={true}
          title={modalState.row.appraisal_library_name}
          kraId={modalState.row.appraisal_library_id}
          description={modalState.row.appraisal_library_description}
          dispatchData={data}
          externalOpen={externalOpen}
          setExternalOpen={setExternalOpen}
        />
      )}
    </Box>
  );
};

export default Skilllibrary;
